(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["demo-walkthrough"] && !Shopify.designMode) return;
  try {
    
  class DemoWalkthrough {
    constructor(root) {
      this.root = root;
      this.tabs = Array.from(root.querySelectorAll('[data-tab]'));
      this.panels = Array.from(root.querySelectorAll('[data-panel]'));
      if (!this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.tab, true));
        tab.addEventListener('keydown', (event) => this.onKeydown(event));
      });

      window.addEventListener('hashchange', () => this.selectFromHash(false));
      this.selectFromHash(false);
    }

    selectFromHash(focus) {
      const hash = window.location.hash.replace('#', '');
      if (hash && this.tabs.some((tab) => tab.dataset.tab === hash)) {
        this.select(hash, focus);
      }
    }

    select(id, updateHash) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.tab === id;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.panel !== id;
      });

      if (updateHash && window.history.replaceState) {
        window.history.replaceState(null, '', `#${id}`);
      }
    }

    onKeydown(event) {
      const index = this.tabs.findIndex((tab) => tab === event.target);
      if (index === -1) return;

      let next = null;
      if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.tabs.length - 1;
      if (next === null) return;

      event.preventDefault();
      const tab = this.tabs[next];
      this.select(tab.dataset.tab, true);
      tab.focus();
    }
  }

  function initDemoWalkthroughs(scope) {
    (scope || document).querySelectorAll('[data-demo-walk]').forEach((root) => {
      if (root.dataset.walkReady) return;
      root.dataset.walkReady = 'true';
      new DemoWalkthrough(root);
    });
  }

  initDemoWalkthroughs();
  document.addEventListener('shopify:section:load', (event) => initDemoWalkthroughs(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
